import React, { useMemo, useState } from 'react'
import { Form, Dropdown } from 'semantic-ui-react'

const TimezoneDisplayWithIcon = () => {
  return (
    <div className="flex items-center">
      <i className="fal fa-globe mr-2" />
      Use local time for each user
    </div>
  )
}

export default function WorkspaceTimezone({
  handleChangeTimezone,
  selectedTimezone,
  timezoneLoading,
  timezoneOptions = [],
}) {
  const [isSearching, setIsSearching] = useState(false)

  // Control how the dropdown item is displayed
  const modifiedTimezoneOptions = useMemo(() => {
    return timezoneOptions.map((opt) => {
      if (opt.value === 'default') {
        return {
          ...opt,
          text: 'Use local time for each user',
          content: <TimezoneDisplayWithIcon />,
        }
      }
      return opt
    })
  }, [timezoneOptions])

  // Controls how the selected value is displayed
  // Check isSearching to prevent the text overlapping
  const trigger = useMemo(() => {
    if (selectedTimezone === 'default' && !isSearching) {
      return <TimezoneDisplayWithIcon />
    }
    return null
  }, [selectedTimezone, isSearching])

  return (
    <React.Fragment>
      <h3 className="flex items-center ui header">Workspace time zone</h3>
      <p>
        Choose a default time zone for your workspace. All filters and exports will use this time
        zone so everyone sees the same data, no matter where they're located.
      </p>

      <Form.Field>
        <label>Time zone</label>
        <Dropdown
          value={selectedTimezone}
          options={modifiedTimezoneOptions}
          selection
          fluid
          placeholder="Select a time zone"
          search
          loading={timezoneLoading}
          onChange={handleChangeTimezone}
          trigger={trigger}
          onSearchChange={(e, data) => {
            setIsSearching(data.searchQuery.length > 0)
          }}
          onClose={() => setIsSearching(false)}
        />
      </Form.Field>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/WorkspaceTimezone/index.js